<div class="PageContent">
    <div class="PageContentTitle">
        <i class="material-icons">app_settings_alt</i>
        {{'AppSettings' | translate}}
    </div>
    <div class="PageContentBody animated fadeIn">
        <div class="TwoThirdsColumn" style="padding-left: 30px;">

            <div class="ColumnTitle">
                <i class="material-icons">manage_accounts</i>
                {{'UsersSettings' | translate}}
            </div>

              <mat-form-field class="fullWidth" appearance="outline">
                <mat-label>{{ 'SearchUser' | translate }}</mat-label>
                <input autocomplete="off" [(ngModel)]="this.SearchTerm" matInput (ngModelChange)="this.searchTermUpdate.next($event)">
                <i class="material-icons SearchUserIcon">search</i>
              </mat-form-field>

              <div class="UsersSearchContainer" *ngIf="this.users?.length > 0;">
                <div class="UsersSearchRow" *ngFor="let u of this.users" (click)="GetUser(u);">
                    [{{u.UserName}}] {{u.UIName}}
                </div>
              </div>

              <mat-form-field appearance="outline" class="fullWidth" *ngIf="this.SelectedUser != null;">
                <mat-label>{{ 'SelectRightType' | translate }}</mat-label>
                <mat-select name="SelectedRightType" [compareWith]="this.parent.compareFn" [(ngModel)]="this.SelectedRightType">
                  <mat-option *ngFor="let t of this.parent.RightTypes" [value]="t" (click)="SelectRightType(t);">
                    {{t.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Role Selector (below rights type selection) -->
              <div class="SearchOverlayTransparent" *ngIf="showRoleResults" (click)="showRoleResults = false"></div>
              <div class="RoleSearchContainer" *ngIf="this.SelectedUser != null && this.RightDetails != null;">
                <div class="RoleSearchBar" (click)="onRoleSearchFocus()">
                  <span class="role-label">{{'UserPageRole' | translate}}</span>
                  <input
                    type="text"
                    class="RoleSearchInput"
                    [placeholder]="'SelectRole' | translate"
                    [(ngModel)]="roleSearchTerm"
                    readonly
                  />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>

                <!-- Role Results Dropdown -->
                <div class="RoleSearchResults" *ngIf="showRoleResults && this.parent.masterData?.Roles?.length > 0">
                  <div class="RoleSearchResult" (click)="selectRole(null)">
                    <div class="RoleResultMain">
                      <i class="material-icons RoleResultIcon">block</i>
                      <span class="RoleResultName RoleResultClear">{{ 'NoRoleRestriction' | translate }}</span>
                    </div>
                  </div>
                  <div class="RoleSearchResult" *ngFor="let role of this.parent.masterData.Roles" (click)="selectRole(role)">
                    <div class="RoleResultMain">
                      <i class="material-icons RoleResultIcon">badge</i>
                      <span class="RoleResultName">{{role.Meaning}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="RightsContainer" *ngIf="this.SelectedRightType != null && this.RightDetails != null;">
                <p class="RightsContainerTitle">{{this.RightDetails.GeneralRightType.Name}}</p>
                <mat-slide-toggle matTooltip="{{ 'AllowedAllCountriesDesc' | translate }}" matTooltipClass='neutral-tool-tip-management' class="RightToggle" [(ngModel)]="RightDetails.AllowedAllCountries">{{'AllowedAllCountries' | translate}}</mat-slide-toggle>
                <mat-slide-toggle matTooltip="{{ 'AllowStoppingDesc' | translate }}" matTooltipClass='neutral-tool-tip-management' *ngIf="RightDetails.GeneralRightType.ID == 1;" class="RightToggle" [(ngModel)]="RightDetails.AllowStopping">{{'AllowStopping' | translate}}</mat-slide-toggle>
                <mat-slide-toggle matTooltip="{{ 'AllowStartingDesc' | translate }}" matTooltipClass='neutral-tool-tip-management' *ngIf="RightDetails.GeneralRightType.ID == 1;" class="RightToggle" [(ngModel)]="RightDetails.AllowStarting">{{'AllowStarting' | translate}}</mat-slide-toggle>
                <mat-slide-toggle matTooltip="{{ 'OnlyAccessOwnTasksDesc' | translate }}" matTooltipClass='neutral-tool-tip-management' *ngIf="RightDetails.GeneralRightType.ID == 2;" class="RightToggle" [(ngModel)]="RightDetails.OnlyAccessOwnTasks">{{'OnlyAccessOwnTasks' | translate}}</mat-slide-toggle>
                <mat-slide-toggle matTooltip="{{ 'SeeOnlyOwnTasksDesc' | translate }}" matTooltipClass='neutral-tool-tip-management' *ngIf="RightDetails.GeneralRightType.ID == 2;" class="RightToggle" [(ngModel)]="RightDetails.SeeOnlyOwnTasks">{{'SeeOnlyOwnTasks' | translate}}</mat-slide-toggle>
                <mat-slide-toggle *ngIf="RightDetails.GeneralRightType.ID == 3;" class="RightToggle" [(ngModel)]="RightDetails.TrackingRight">{{'TrackingRight' | translate}}</mat-slide-toggle>
                <mat-slide-toggle *ngIf="RightDetails.GeneralRightType.ID == 3;" class="RightToggle" [(ngModel)]="RightDetails.TrackingHistoryRights">{{'TrackingHistoryRights' | translate}}</mat-slide-toggle>
                <mat-slide-toggle *ngIf="RightDetails.GeneralRightType.ID == 3;" class="RightToggle" [(ngModel)]="RightDetails.PickupRights">{{'PickupRights' | translate}}</mat-slide-toggle>
                <mat-slide-toggle *ngIf="RightDetails.GeneralRightType.ID == 3;" class="RightToggle" [(ngModel)]="RightDetails.ShippingRights">{{'ShippingRights' | translate}}</mat-slide-toggle>
                <mat-slide-toggle matTooltip="{{ 'ExportRightsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management' class="RightToggle" [(ngModel)]="RightDetails.ExportRights">{{'ExportRights' | translate}}</mat-slide-toggle>
                <mat-slide-toggle matTooltip="{{ 'UICopyRightsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management' class="RightToggle" [(ngModel)]="RightDetails.UICopyRights">{{'UICopyRights' | translate}}</mat-slide-toggle>
                <mat-slide-toggle class="RightToggle" [(ngModel)]="RightDetails.CreatingRights">{{'CreatingRights' | translate}}</mat-slide-toggle>
                <mat-slide-toggle class="RightToggle" [(ngModel)]="RightDetails.EditRights">{{'EditRights' | translate}}</mat-slide-toggle>
                <mat-slide-toggle class="RightToggle" [(ngModel)]="RightDetails.CancelingRights">{{'CancelingRights' | translate}}</mat-slide-toggle>
                <mat-slide-toggle class="RightToggle" [(ngModel)]="RightDetails.DeletingRights">{{'DeletingRights' | translate}}</mat-slide-toggle>
              </div>

              <div class="URLsContainer" *ngIf="RightDetails != null;">
                <p class="RightsContainerTitle">
                    <span matTooltip="{{ 'ImpactedURLsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'ImpactedURLs' | translate}}</span>
                </p>
                <div class="RightsCountriesContainer">
                    <div *ngFor="let url of this.RightDetails.ImpactedURLs">
                        <mat-checkbox [(ngModel)]="url.IsSelected">{{url.Path}}</mat-checkbox>
                    </div>
                </div>
              </div>
        </div>
        <div class="OneThirdColumn">
            <div class="GrayOverlay" *ngIf="RightDetails?.AllowedAllCountries == true;"></div>
            <div *ngIf="RightDetails != null;" style="padding-top: 180px;">
                <p matTooltip="{{ 'AllowedCountriesDesc' | translate }}" matTooltipClass='neutral-tool-tip-management' class="RightsContainerTitle">{{'AllowedCountries' | translate}}</p>
                <div class="RightsCountriesContainer">
                    <div *ngFor="let country of this.RightDetails.AllowedCountries">
                        <mat-checkbox [(ngModel)]="country.IsSelected">{{country.Name}}</mat-checkbox>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="PageContentBodyCommands">
        <button mat-raised-button class="MainCommandButton" (click)="AddUpdateUserManagementInfo(this.SelectedUser);">
            <i class="material-icons">save_alt</i>
            {{'Update' | translate}}
        </button>
    </div>
</div>
